
import {catchError, tap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { SecurityAuthApi } from 'cad/common/services/api/security/auth/auth';
import { AuthInterceptorService } from 'common/services/http-interceptor/auth-interceptor-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {


  constructor(private securityAuthApi: SecurityAuthApi, private authService: AuthInterceptorService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    // Get the auth header from the service.
    let authToken = this.securityAuthApi.getAuthToken();
    // Clone the request to add the new header.
    if(authToken) {
      authReq = req.clone({setHeaders: {Authorization: authToken}});
    }
    if(req.url.endsWith('security/logout')) {
      authReq = req.clone({setHeaders: {Authorization: 'NTLM'}});
    }

    return next
      .handle(authReq).pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            // todo handle a response if we need to
          }
        }),
        // **401 HANDLING + MSAL RETRY**
        catchError((err: any) => {
          // If not an HttpErrorResponse, just rethrow
          if (!(err instanceof HttpErrorResponse)) {
            return throwError(err);
          }

          // Only handle 401
          if (err.status !== 401) {
            return throwError(err);
          }

          // Check if MSAL retry should happen
          const isAuthTrigger =  err.headers?.get('X-Auth-Trigger') === 'true';

          // Prevent retry loops
          const alreadyRetried =  authReq.headers.has('x-msal-retried');

          if (!isAuthTrigger || alreadyRetried) {
            // Legacy behavior
            console.error('401 unauthorized');
            this.authService.unauthorizedSubject.next();
            return throwError(err);
          }

          // MSAL RETRY
          const stripped = req.clone({
            headers: req.headers
              .delete('Authorization') // remove Basic so MSAL injects Bearer
              .set('X-Auth-Trigger', 'true')
              .set('x-msal-retried', 'true')
          });

          // Return the NEW observable so a new request flows through MsalInterceptor
          return next.handle(stripped);
        })
      );
  }
}
